import { createEvent } from '@toeverything/infra';

export const ServerStarted = createEvent('ServerStarted');
